import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import StyledSelect from '../StyledReactSelect';

const EmailLanguage = ({ intl: { formatMessage }, onChange, disabled, initialValue = 'EN', ...props }) => {
  const options = [
    {
      value: 'EN',
      label: `🇬🇧 ${formatMessage({ id: 'translations.english' })}`
    },
    {
      value: 'FR',
      label: `🇫🇷 ${formatMessage({ id: 'translations.french' })}`
    },
    {
      value: 'NL',
      label: `🇳🇱 ${formatMessage({ id: 'translations.dutch' })}`
    },
    {
      value: 'DE',
      label: `🇩🇪 ${formatMessage({ id: 'translations.german' })}`
    }
  ];

  return (
    <StyledSelect
      id="email-language-selector"
      className="react-select-container email-language"
      classNamePrefix="react-select"
      options={options}
      onChange={(e) => onChange(e)}
      value={options.find((o) => o.value === initialValue)}
      isDisabled={disabled}
      {...props}
    />
  );
};

EmailLanguage.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func
  }),
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  initialValue: PropTypes.string
};

export default injectIntl(EmailLanguage);
